/**
 * 個人情報登録ページ
 */

class Setting {
    constructor() {

        // 職種適用
        this.applyOccupationBtnEls = document.querySelectorAll('.apply-occupation');
        this.applyOccupationBtnEls.forEach(el => el.addEventListener('click', () => {
            this.applyOccupation(el);
        }));

        // 勤務年数変更
        this.changeYearEls = document.querySelectorAll('.change-year');
        this.changeYearEls.forEach(el => el.addEventListener('change', () => {
            this.changeYear(el);
        }));

        // 職務経歴追加
        this.addCareerBtnEl = document.getElementById('add-career');
        this.addCareerBtnEl.addEventListener('click', ev => {
            this.addCareer(ev);
        });

        // 職務経歴削除
        this.deleteCareerBtnEls = document.querySelectorAll('.delete-career');
        this.deleteCareerBtnEls.forEach(el => el.addEventListener('click', ev => {
            this.deleteCareer(el, ev);
        }));

        // スキルチェックボックスをON、OFF
        this.skillCheckEls = document.querySelectorAll('[type=checkbox][name=skill_check]');
        this.skillCheckEls.forEach(el => el.addEventListener('change', () => {
            this.toggleSkill(el);
        }));

        // その他のスキルを追加
        this.addOtherSkillBtnEl = document.getElementById('add-other-skill');
        this.addOtherSkillBtnEl.addEventListener('click', ev => {
            this.addOthreSkill(ev);
        });

        // スキル適用
        this.applySkillBtnEl = document.getElementById('apply-skill');
        this.applySkillBtnEl.addEventListener('click', () => {
            this.applySkill();
        });

        // スキルレベル変更
        this.changeLevelEls = document.querySelectorAll('.change-level');
        this.changeLevelEls.forEach(el => el.addEventListener('click', ev => {
            this.changeLevel(el, ev);
        }));

        this.skillList();

        this.init();
    }

    init() {
        const ulEl = document.getElementsByClassName('skill-and-level')[0];
        ulEl.querySelectorAll('li:not(.skill-and-level-template)').forEach(el => {
            const skillId = el.dataset.skillId;

            // checkbox
            if( skillId.indexOf('free-') === -1 ){
                const targetEl = document.querySelector(`[type=checkbox][name=skill_check][value="${skillId}"]`);
                targetEl.checked = true;
                this.toggleSkill(targetEl);
            }
            // text
            else{
                const inputEl = document.getElementsByName('other_skill_input')[0];
                inputEl.value = skillId.replace('free-', '');
                this.addOthreSkill();
            }

        });
    }

    /**
     * ページ初期化時に実行
     */
    skillList(){
        // ボックススライド
        $('.toggle-skill-category').on('click', function(ev){
            ev.preventDefault();

            $(this).next().slideToggle();

            if ($(this).children('.toggle-btn').hasClass('active')) {
                $(this).children('.toggle-btn').removeClass('active');
            }else {
                $(this).children('.toggle-btn').addClass('active');
            }
        });
    }

    /**
     * 職種適用
     */
    applyOccupation(el) {
        const tdEl = el.closest('td');
        const checkedEl = tdEl.querySelector('[name^=occupation_check]:checked');

        tdEl.querySelector('.occupation-and-year').style.display = null;
        tdEl.querySelector('.occupation-and-year p').textContent = checkedEl.dataset.occupationName;
        tdEl.querySelector('[name^="career["]').setAttribute('name', `career[${checkedEl.value}]`);

        window.common.closeModal(el.closest('.modal-container'));
    }

    /**
     * 勤務年数変更
     */
    changeYear(el) {
        el.closest('td').querySelector('[name^="career["]').value = el.options[el.selectedIndex].value;
    }

    /**
     * 職務経歴追加
     */
    addCareer(ev) {
        ev.preventDefault();

        const careerTableWrapEls = document.getElementsByClassName('career-table-wrap');

        // 新DOM作成
        const $newEl = $('.career-template').clone(true);
        const newEl = $newEl[0];
        const count = parseInt(
            Array.from(careerTableWrapEls)
                .reduce((a,b) => a.dataset.count > b.dataset.count ? a : b)
                .dataset.count
            ) + 1;
        // 新DOM初期化
        newEl.dataset.count = count;
        newEl.classList.remove('career-template');
        newEl.querySelector('.delete-career').style.display = null;
        newEl.querySelector('.occupation-and-year').style.display = 'none';
        newEl.querySelector('.change-year').options[0].selected = true;
        newEl.querySelector('[name^="career["]').value = '';
        newEl.querySelector('[name^="career["]').setAttribute('name', `career[]`);
        newEl.querySelector('[name="career_content[0]"]').value = '';
        newEl.querySelector('[name="career_content[0]"]').setAttribute('name', `career_content[${count}]`);
        newEl.querySelector('.modal-open').dataset.target = 'modal-occupation'+count;
        newEl.querySelector('.modal-container').id = 'modal-occupation'+count;
        newEl.querySelectorAll('.toggle-skill-category .toggle-btn').forEach(_el => {
            _el.classList.add('active');
        });
        newEl.querySelectorAll('.skill-list-wrap ul').forEach(_el => {
            _el.style.display = 'none';
        });
        newEl.querySelectorAll('input[name^=occupation_check]').forEach(_el => {
            _el.checked = false;
        });
        // 新DOMイベント登録
        newEl.querySelector('.modal-open').addEventListener('click', ev => window.common.openModal(ev.currentTarget));
        newEl.querySelectorAll('.modal-close, .modal-cancel').forEach(
            _el => _el.addEventListener('click', ev => window.common.closeModal(ev.currentTarget)
        ));
        newEl.querySelector('.apply-occupation').addEventListener('click', ev => this.applyOccupation(ev.currentTarget));
        newEl.querySelector('.change-year').addEventListener('change', ev => this.changeYear(ev.currentTarget));
        newEl.querySelector('.delete-career').addEventListener('click', ev => this.deleteCareer(ev.currentTarget, ev));

        // 新DOM追加
        const nowLength = careerTableWrapEls.length;
        careerTableWrapEls[nowLength-1].after(newEl);
    }

    /**
     * 職務経歴削除
     */
    deleteCareer(el, ev) {
        ev.preventDefault();
        el.closest('.career-table-wrap').remove();
    }

    /**
     * スキルチェックボックスをON、OFF
     */
    toggleSkill(el) {
        const selectedAreaEl = document.getElementsByClassName('selected-skill')[0];

        // ON
        if( el.checked ){
            const selectedSkillEl = document.createElement('button');
            selectedSkillEl.textContent = el.dataset.skillName;
            selectedSkillEl.dataset.skillId = el.value;

            // 削除イベント登録しておく
            selectedSkillEl.addEventListener('click', _ev => {
                _ev.preventDefault();
                el.checked = false;
                selectedSkillEl.remove();
            });

            selectedAreaEl.appendChild(selectedSkillEl);
        }
        // OFF
        else{
            selectedAreaEl.querySelector(`button[data-skill-id="${el.value}"]`).remove();
        }
    }

    /**
     * その他のスキルを追加
     */
    addOthreSkill(ev) {
        if( ev ){
            ev.preventDefault();
        }

        const inputEl = document.getElementsByName('other_skill_input')[0];
        if( inputEl.value == '' ){
            return false;
        }

        const hiddenEl = document.createElement('input');
        hiddenEl.setAttribute('type', 'hidden');
        hiddenEl.setAttribute('name', 'other_skill[]');
        hiddenEl.value = 'free-'+inputEl.value;
        hiddenEl.dataset.skillName = inputEl.value;

        const otherSkillLen = document.getElementsByName('other_skill[]').length;
        if( otherSkillLen > 0 ){
            document.getElementsByName('other_skill[]')[otherSkillLen-1].after(hiddenEl);
        }else{
            document.getElementsByName('other_skill_input')[0].after(hiddenEl);
        }

        const selectedAreaEl = document.getElementsByClassName('selected-skill')[0];
        const selectedSkillEl = document.createElement('button');
        selectedSkillEl.textContent = inputEl.value;

        // 削除イベント登録しておく
        selectedSkillEl.addEventListener('click', _ev => {
            _ev.preventDefault();
            inputEl.value = '';
            hiddenEl.remove();
            selectedSkillEl.remove();
        });

        selectedAreaEl.appendChild(selectedSkillEl);
        inputEl.value = '';
    }

    /**
     * スキル追加
     */
    applySkill() {
        const ulEl = document.getElementsByClassName('skill-and-level')[0];
        const liOriginalEl = document.getElementsByClassName('skill-and-level-template')[0];

        const existSkills = Array.from(ulEl.querySelectorAll('li:not(.skill-and-level-template)'));
        const existSkillIds = existSkills.map(el => el.dataset.skillId);

        // テキスト入力もcheckedSkillsに含める
        const checkedSkills = Array.from(document.querySelectorAll('input[type=checkbox][name=skill_check]:checked'));
        const otherSkillEls = Array.from(document.getElementsByName('other_skill[]'));
        for( let otherSkillEl of otherSkillEls ){
            if( otherSkillEl.value != '' ){
                checkedSkills.push(otherSkillEl);
            }
        }
        const checkedSkillIds = checkedSkills.map(el => el.value);

        // 1. 削除
        for( let existSkill of existSkills ){
            const existSkillId = existSkill.dataset.skillId;
            if( checkedSkillIds.includes(existSkillId) ){
                continue;
            }
            existSkill.remove();
        }

        // 2. 追加
        for( let skill of checkedSkills ){
            const skillId = skill.value;
            if( existSkillIds.includes(skillId) ){
                continue;
            }
            const liEl = liOriginalEl.cloneNode(true);
            liEl.classList.remove('skill-and-level-template');
            liEl.dataset.skillId = skillId;
            liEl.querySelector('p').textContent = skill.dataset.skillName;
            liEl.querySelector('[name="skill[]"]').value = 1;
            liEl.querySelector('[name="skill[]"]').setAttribute('name', `skill[${skillId}]`);
            liEl.querySelectorAll('button').forEach(el => el.addEventListener('click', ev => this.changeLevel(el, ev)));
            ulEl.appendChild(liEl);
        }

        window.common.closeModal(this.applySkillBtnEl.closest('.modal-container'));
    }

    changeLevel(el, ev) {
        ev.preventDefault();

        const level = el.dataset.level;

        el.parentNode.querySelectorAll('button').forEach(_el => {
            if( _el.dataset.level > level ){
                _el.classList.remove('active');
            }else{
                _el.classList.add('active');
            }
        });

        el.closest('li').querySelector('[name^="skill["]').value = level;
    }

}

const setting = new Setting();
